'use client';

import React from 'react';
import { ThemeProvider } from '@/components/ThemeProvider';
import DashboardLayout from '@/components/DashboardLayout';
import BinaryGenealogyTree from './components/BinaryGenealogyTree';

export default function MyTeamPage() {
  return (
    <ThemeProvider>
      <DashboardLayout variant="member">
        <div className="p-4 lg:p-6 max-w-screen-2xl mx-auto space-y-4">
          <div>
            <h1 className="text-2xl font-bold text-foreground">My Team</h1>
            <p className="text-sm text-muted-foreground mt-1">Binary genealogy tree of your network</p>
          </div>
          <BinaryGenealogyTree />
        </div>
      </DashboardLayout>
    </ThemeProvider>
  );
}
